import { render, staticRenderFns } from "./WorkerContactEditForm.vue?vue&type=template&id=66cd526a&scoped=true&"
import script from "./WorkerContactEditForm.vue?vue&type=script&lang=js&"
export * from "./WorkerContactEditForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkerContactEditForm.vue?vue&type=style&index=0&id=66cd526a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd526a",
  null
  
)

export default component.exports